import { PROGRAM_STATUS } from "@/store/modules/basic_programs/constants";
import moment from "moment";
import _ from "lodash";
import { panels } from "../_consts";
import "moment-timezone";
import consts from "@/_consts";

function diffDate(startDate, endDate) {
  const d1 = new Date(startDate);
  const d2 = new Date(endDate);
  const diffTime = Math.abs(d2.getTime() - d1.getTime());
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
}

function diffMonth(startDate, endDate) {
  const d1 = new Date(startDate);
  const d2 = new Date(endDate);
  var months;
  months = (d2.getFullYear() - d1.getFullYear()) * 12;
  months -= d1.getMonth();
  months += d2.getMonth();
  return months <= 0 ? 0 : months;
}

// return 0 if equal
function compareDatetime(d1, d2) {
  return moment(d1).valueOf() - moment(d2).valueOf();
}

function getProgramStatus(startDate, endDate) {
  let status = PROGRAM_STATUS.DRAFT;
  if (startDate && endDate) {
    const currDate = new Date();
    let programStartDate = new Date(startDate);
    let programEndDate = new Date(endDate);
    if (programEndDate < currDate) {
      status = PROGRAM_STATUS.COMPLETED;
    } else if (programStartDate <= currDate) {
      status = PROGRAM_STATUS.ACTIVE;
    }
  }
  return status;
}

function updateTimezoneButFreezeDate(dateString, rightTimezone, localTimezone) {
  // We want to show the dateTime follow to the rightTimeZone on the browser
  // has the same (or different) timezone.
  // DateTime which you see on the UI, its timezone is rightTimezone
  // We cannot change the timezone of calendar, so we just convert follow this way

  if (!dateString || !rightTimezone || !localTimezone) {
    return null;
  }
  const dateWithRightTimezone = moment.tz(dateString, rightTimezone).format();
  const datePattern = /(\d{4}).(\d{2}).(\d{2})T(\d{2}):(\d{2})/;
  const dateUTC = datePattern.exec(dateWithRightTimezone);
  const year = dateUTC[1];
  const month = dateUTC[2];
  const day = dateUTC[3];
  const hours = dateUTC[4];
  const minutes = dateUTC[5];
  return moment
    .tz(`${year}-${month}-${day} ${hours}:${minutes}`, localTimezone)
    .format();
}

function getDateTime(dateString, time, timezone) {
  const newDate = new Date(dateString);
  let year = newDate.getFullYear();
  let month = newDate.getMonth() + 1;
  month = month < 10 ? "0" + month : month;
  let day = newDate.getDate();
  day = day < 10 ? "0" + day : day;
  let hours =
    time.A === "PM"
      ? Number(time.hh) === 12
        ? 12
        : Number(time.hh) + 12
      : Number(time.hh);
  hours = hours < 10 ? "0" + hours : hours;
  let minutes = Number(time.mm);
  minutes = minutes < 10 ? "0" + minutes : minutes;
  let result = moment.tz(
    year + "-" + month + "-" + day + " " + hours + ":" + minutes,
    timezone
  );
  return result.utc().format();
}

function getDateTimeNoTimezone(dateString, time) {
  const newDate = new Date(dateString);
  let year = newDate.getFullYear();
  let month = newDate.getMonth() + 1;
  month = month < 10 ? "0" + month : month;
  let day = newDate.getDate();
  day = day < 10 ? "0" + day : day;

  // Adjust hours based on "AM" or "PM"
  let hours = Number(time.hh);
  if (time.A === "PM" && hours < 12) {
    hours += 12;
  } else if (time.A === "AM" && hours === 12) {
    hours = 0;
  }

  hours = hours < 10 ? "0" + hours : hours;
  let minutes = Number(time.mm);
  minutes = minutes < 10 ? "0" + minutes : minutes;

  let result = moment(`${year}-${month}-${day} ${hours}:${minutes}`);
  return result._i.replace(" ", "T") + ":00";
}

function dateTimeCombiner(date, time) {
  const combinedDate = new Date(date);

  combinedDate.setHours(time.HH);
  combinedDate.setMinutes(time.mm);
  combinedDate.setSeconds(time.ss);

  const year = combinedDate.getFullYear();
  const month = String(combinedDate.getMonth() + 1).padStart(2, '0');
  const day = String(combinedDate.getDate()).padStart(2, '0');
  const hours = String(combinedDate.getHours()).padStart(2, '0');
  const minutes = String(combinedDate.getMinutes()).padStart(2, '0');
  const seconds = String(combinedDate.getSeconds()).padStart(2, '0');

  const formattedDate = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;

  return formattedDate;
}

function getDateBaseOnLocalDate(dateString) {
  const newDate = new Date(dateString);
  let year = newDate.getFullYear();
  let month = newDate.getMonth() + 1;
  month = month < 10 ? "0" + month : month;
  let day = newDate.getDate();
  day = day < 10 ? "0" + day : day;
  let hours = newDate.getHours();
  hours = hours < 10 ? "0" + hours : hours;
  let minutes = newDate.getMinutes();
  minutes = minutes < 10 ? "0" + minutes : minutes;
  let result = moment.tz(
    year + "-" + month + "-" + day + " " + hours + ":" + minutes,
    moment.tz.guess()
  );
  let offset = moment().utcOffset();
  let time = moment.duration(offset, "minutes");
  if (offset > 0) {
    result.subtract(time);
  } else {
    let offsetNegative = offset / -1;
    time = moment.duration(offsetNegative, "minutes");
    result.add(time);
  }
  return result.utc().format();
}

function getDateFromDateTime(dateString) {
  if (dateString.includes("T")) {
    return dateString.split("T")[0];
  } else {
    return "";
  }
}

function getDateFromDateTimeObject(dateTime) {
  const newDate = moment.utc(dateTime);
  let year = newDate.year();
  let month = newDate.month() + 1;
  month = month < 10 ? "0" + month : month;
  let day = newDate.date();
  day = day < 10 ? "0" + day : day;
  return year + "-" + month + "-" + day;
}

function hours12to24(h, pm) {
  return h === 12 ? (pm ? 12 : 0) : pm ? h + 12 : h;
}

function hours24to12(h) {
  return {
    hour: ((h + 11) % 12) + 1,
    pm: h >= 12
  };
}

function prettyStringFromCode(s) {
  s = s ? s : "";
  s = s
    .toLowerCase()
    .split("_")
    .join(" ");
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export function isValidDateString(s) {
  let reg = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[0-1])\/(\d{4})$/;
  let matched = s.match(reg);
  if (matched && matched.length === 4) {
    let m = parseInt(matched[1]);
    let d = parseInt(matched[2]);
    let y = parseInt(matched[3]);
    switch (m) {
      case 4:
      case 6:
      case 9:
      case 11:
        return d < 31;
      case 2:
        if (y % 4 === 0 && (y % 100 !== 0 || y % 400 === 0)) {
          return d < 30;
        }
        return d < 29;
      default:
        return true;
    }
  }
  return false;
}

export function getFormattedDate(s) {
  return moment(s).format("MM/DD/YYYY");
}

export function convertPermissions(permissions) {
  let marker = "__";
  if (!Array.isArray(permissions)) return permissions;
  if (permissions.includes(null)) return permissions;
  return _.chain(permissions)
    .groupBy(per => per.split(marker)[1])
    .map((value, key) => {
      return {
        entity: key,
        servicePrefix: value && value[0].split(marker)[0],
        actions: value.map(c => c.split(marker)[2]),
        actionFriendlyName: value.reduce((acc, cur) => {
          return Object.assign(acc, {
            [cur.split(marker)[2]]: cur.split(marker)[2].replace(/_/g, " ")
          });
        }, {})
      };
    })
    .value();
}

export function isClientPanel(instance) {
  const routeHasPanel = instance.$route.matched.find(
    record =>
      record && record.meta.panel && Object.keys(record.meta.panel).length > 0
  );
  return routeHasPanel && routeHasPanel.meta.panel === panels.client;
}

export function getPanelRoute(instance) {
  return isClientPanel(instance)
    ? instance.$dashboardRoute.items
    : instance.$adminRoute.items;
}

export function formatPhoneNumber(phoneNumberString) {
  var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
  var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    var intlCode =
      match[1] === undefined || match[1] === "1" || match[1] === "+1"
        ? "+1"
        : match[1];
    return [intlCode, match[2], match[3], match[4]].join("");
  }
  return null;
}

function removeZFromString(str) {
  if (str && str.length > 0) {
    // Remove the time zone offset "+XX:XX" or "-XX:XX" if it exists
    const withoutTimezone = str.replace(/(\+|-)\d{2}:\d{2}/, "");
    // Remove the "Z"
    return withoutTimezone.replace("Z", "");
  }
  return null;
}

function combineDateAndTime(date, time) {
  return date && date.length > 0 ? date + "T" + time : null;
}

function concatZFromString(str) {
  if (str && str.length > 0) {
    // Remove the time zone offset "+XX:XX" or "-XX:XX" if it exists
    const withoutTimezone = str.replace(/(\+|-)\d{2}:\d{2}/, "");
    // Add "Z" if it's not already there
    return withoutTimezone.endsWith("Z") ? withoutTimezone : `${withoutTimezone}Z`;
  }
  return null;
}

function getLocalDate(str) {
  if (str && str.includes('T')) {
    const dateTime = removeZFromString(str);
    return dateTime.split('T')[0]
  }
  return str
}

function calculateAndStoreRefreshTimestamp(idToken) {
  const expiresInSeconds = idToken.getExpiration() - idToken.getIssuedAt();
  const refreshAt =  idToken.getIssuedAt() + (expiresInSeconds * consts.TIMEOUT_VARIABLES.USER_ACTIVITY_TTL_FACTOR);
  const refreshTimestamp = moment(refreshAt * 1000);
  sessionStorage.setItem(consts.LOCAL_STORE.refreshTokenAt, refreshTimestamp.toISOString());
}

function toItemsRange(pagination) {
  const firstItem = Math.min((pagination.current_page - 1) * pagination.per_page + 1, pagination.total);
  const lastItem = Math.min(pagination.current_page * pagination.per_page, pagination.total);

  return `${firstItem}-${lastItem}`;
}

export default {
  diffDate,
  diffMonth,
  getProgramStatus,
  getDateTime,
  getDateTimeNoTimezone,
  dateTimeCombiner,
  updateTimezoneButFreezeDate,
  hours12to24,
  hours24to12,
  compareDatetime,
  prettyStringFromCode,
  isValidDateString,
  getFormattedDate,
  convertPermissions,
  isClientPanel,
  getPanelRoute,
  formatPhoneNumber,
  getDateBaseOnLocalDate,
  getDateFromDateTime,
  removeZFromString,
  combineDateAndTime,
  getDateFromDateTimeObject,
  concatZFromString,
  getLocalDate,
  calculateAndStoreRefreshTimestamp,
  toItemsRange
};



// WEBPACK FOOTER //
// ./src/utils/common.js